import React, { useEffect } from 'react';
import { DocumentSidebar, Session } from './DocumentSidebar';

interface Props {
  open: boolean;
  onClose: () => void;
  selectedIds: Set<string>;
  onSelectionChange: (ids: Set<string>) => void;
  onSessionRestore: (id: string) => void;
  sessions: Session[];
  onSessionsReload: () => void;
}

export const MobileSheet: React.FC<Props> = ({
  open,
  onClose,
  selectedIds,
  onSelectionChange,
  onSessionRestore,
  sessions,
  onSessionsReload,
}) => {
  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <div
      className={`ai-mobile-sheet-overlay${open ? ' open' : ''}`}
      onClick={onClose}
      aria-hidden={!open}
    >
      <div className="ai-mobile-sheet" onClick={e => e.stopPropagation()}>
        <div className="ai-mobile-sheet-header">
          <span>Filter Documents</span>
          <button className="ai-mobile-sheet-close" onClick={onClose}>✕</button>
        </div>
        <div className="ai-mobile-sheet-body">
          <DocumentSidebar
            selectedIds={selectedIds}
            onSelectionChange={onSelectionChange}
            onSessionRestore={(id) => { onSessionRestore(id); onClose(); }}
            sessions={sessions}
            onSessionsReload={onSessionsReload}
          />
        </div>
      </div>
    </div>
  );
};
